export default __webpack_public_path__ + "static/media/voice003_content.60989bf3.png";